import { logger } from '~/features/logging/logger';

import { CatalogFilterLocaleData } from './get-catalog-filter-data-from-server';

export async function getCatalogFilterLocaleMetadata(locale: string): Promise<CatalogFilterLocaleData | null> {
  try {
    const response = await fetch(`/api/get-catalog-filter-data?locale=${encodeURIComponent(locale)}`);

    if (!response.ok) {
      if (response.status === 404) {
        return null; // Locale not found
      }
      throw new Error('Error fetching catalog filter locale metadata');
    }

    const data = await response.json();
    return data as CatalogFilterLocaleData;
  } catch (error) {
    logger.error('Error fetching catalog filter locale metadata', {
      file: 'src/features/catalog/controllers/get-catalog-filter-locale-metadata.ts',
      function: 'getCatalogFilterLocaleMetadata',
      locale,
      error,
    });

    return null;
  }
}
